/* ==========================================================================
   assets/on-modal.js
   The black "i" pop-up of the product spec cards (sections/on-product-specs.liquid).

   Markup it expects (written by the section):
     <on-spec-modal>
       <button data-on-modal-open aria-expanded="false" aria-controls="ID">i</button>
       <div id="ID" class="on-modal" role="dialog" hidden>
         <button data-on-modal-close>X</button>
         <div data-on-modal-body tabindex="0">text</div>
       </div>
     </on-spec-modal>

   Behaviour (same as on.ae):
     - the "i" button opens the pop-up over its card, only one pop-up is open at a time
     - X button, Esc, a click anywhere outside, or tabbing out of the pop-up closes it
     - focus moves to the text (so keyboard and screen-reader users can read / scroll it), Esc and X give focus back to the "i"
   No dependencies. Safe to load more than once.
   ========================================================================== */
(function () {
  if (window.customElements && window.customElements.get('on-spec-modal')) return;
  if (!window.customElements) return;

  var OPEN_EVENT = 'on-spec-modal:open';

  class OnSpecModal extends HTMLElement {
    connectedCallback() {
      this.opener = this.querySelector('[data-on-modal-open]');
      this.panel = this.querySelector('.on-modal');
      this.closer = this.querySelector('[data-on-modal-close]');
      this.body = this.querySelector('[data-on-modal-body]');
      if (!this.opener || !this.panel) return;

      this.abort = new AbortController();
      var sig = { signal: this.abort.signal };

      this.opener.addEventListener('click', function () { this.isOpen() ? this.close(true) : this.open(); }.bind(this), sig);
      if (this.closer) this.closer.addEventListener('click', function () { this.close(true); }.bind(this), sig);

      this.panel.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.stopPropagation(); this.close(true); }
      }.bind(this), sig);
      this.opener.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && this.isOpen()) { e.stopPropagation(); this.close(true); }
      }.bind(this), sig);

      /* tabbing out of the pop-up (and the "i") closes it */
      this.addEventListener('focusout', function (e) {
        var next = e.relatedTarget;
        if (this.isOpen() && next && !this.contains(next)) this.close(false);
      }.bind(this), sig);

      /* click / tap outside */
      document.addEventListener('click', function (e) {
        if (this.isOpen() && !this.contains(e.target)) this.close(false);
      }.bind(this), Object.assign({ capture: true }, sig));

      /* another pop-up opened */
      document.addEventListener(OPEN_EVENT, function (e) {
        if (e.detail !== this && this.isOpen()) this.close(false);
      }.bind(this), sig);

      /* the theme editor re-renders sections: nothing to clean up beyond the listeners above */
    }

    disconnectedCallback() {
      if (this.abort) this.abort.abort();
    }

    isOpen() {
      return !!this.panel && !this.panel.hasAttribute('hidden');
    }

    open() {
      document.dispatchEvent(new CustomEvent(OPEN_EVENT, { detail: this }));
      this.panel.removeAttribute('hidden');
      this.opener.setAttribute('aria-expanded', 'true');
      var target = this.body || this.closer || this.panel;
      try { target.focus({ preventScroll: true }); } catch (err) { target.focus(); }
      /* the box reaches below its card: make sure all of it is on screen */
      if (this.panel.scrollIntoView) {
        try { this.panel.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (err) { /* old browsers */ }
      }
    }

    close(returnFocus) {
      if (!this.isOpen()) return;
      this.panel.setAttribute('hidden', '');
      this.opener.setAttribute('aria-expanded', 'false');
      if (this.body) this.body.scrollTop = 0;
      if (returnFocus) {
        try { this.opener.focus({ preventScroll: true }); } catch (err) { this.opener.focus(); }
      }
    }
  }

  window.customElements.define('on-spec-modal', OnSpecModal);
})();